<template>
  <div class="container">
    <div class="titles">
      <div class="header">
        <div class="header_name">政府监管</div>
        <div class="header_phone">
          <i class="el-icon-phone-outline"></i>
          <span>400-8008-8008</span>
          <i title="切换主页" @click="$router.push('/Home')" class="el-icon-s-home"></i>
        </div>
      </div>
    </div>
    <div class="content">
      <div class="bgLogin">
        <div class="login_box">
          <div>登录</div>
          <el-form :model="ruleForm" status-icon :rules="rules" ref="ruleForm">
            <el-form-item prop="username">
              <i class="el-icon-user-solid"></i>
              <el-input
                v-model.trim="ruleForm.username"
                autocomplete="off"
                placeholder="请输入账号"
                clearable
              ></el-input>
            </el-form-item>
            <el-form-item prop="password">
              <i class="el-icon-lock"></i>
              <el-input
                show-password
                v-model.trim="ruleForm.password"
                autocomplete="off"
                placeholder="请输入密码"
                clearable
              ></el-input>
            </el-form-item>
            <el-form-item prop="captchaCode">
              <div class="codeBox">
                <el-input
                  v-model="ruleForm.captchaCode"
                  autocomplete="off"
                  placeholder="请输入验证码"
                  style="width: 60%"
                  clearable
                ></el-input>
                <img :src="captchaSrc" @click="uploadImg" alt="" />
              </div>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="submitForm('ruleForm')"
                >登 录</el-button
              >
            </el-form-item>
          </el-form>
        </div>
      </div>
    </div>
    <bottom-url />
  </div>
</template>
<script>
import { getVerificationCode, loginPlatform } from '@/API/login/login';
import bottomUrl from '@/components/bottomUrl/bottomUrl.vue';
export default {
  name: 'Login',
  components: {
    bottomUrl,
  },
  data() {
    return {
      ruleForm: {
        username: '',
        password: '',
        deviceId: '',
        captchaCode: '',
        appkey: 't-app-manage@1004', // 前台项目应用key
      },
      rules: {
        username: [{ required: true, trigger: 'blur', message: '请输入账号' }],
        password: [{ required: true, trigger: 'blur', message: '请输入密码' }],
        captchaCode: [
          { required: true, trigger: 'blur', message: '请输入验证码' },
        ],
      },
      loadingText: {
        lock: true,
        text: '拼命加载中......',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.5)',
      },
      captchaSrc: '',
    };
  },
  methods: {
    // 刷新验证码
    uploadImg() {
      this.getMsgCode();
    },
    getMsgCode() {
      this.ruleForm.deviceId = JSON.stringify(new Date().getTime());
      getVerificationCode(this.ruleForm.deviceId)
        .then((res) => {
          const base64 = btoa(
            new Uint8Array(res).reduce(
              (data, byte) => data + String.fromCharCode(byte),
              '',
            ),
          );
          // 设置图片src
          this.captchaSrc = `data:image/png;base64,${base64}`;
        })
        .catch((error) => {
          console.error('获取验证码失败:', error);
          this.$message.error('验证码加载失败，请重试');
        });
    },
    // 表单验证
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.login();
        } else {
          this.ruleForm = {
            username: '',
            password: '',
            deviceId: '',
            appkey: 't-app-manage@1004', // 前台项目应用key
          };
          return false;
        }
      });
    },
    // 登录
    login() {
      const loading = this.$loading(this.loadingText);
      loginPlatform(this.ruleForm).then((res) => {
        if (res.code === 200) {
          this.$message.success('登录成功!');
          this.$store.commit('changeSupervisionUser', res.data);
          this.$store.commit('SET_SupervisionLoggedIn', true);
          localStorage.setItem('supervisionToken', res.data.accessToken);
          // 登录成功后，检查是否有 redirect 参数
          const redirect = this.$route.query.redirect;
          if (redirect) {
            this.$router.push(redirect).then(() => {
              location.reload();
            });
          } else {
            this.$router.push('/supervisionHomepage').then(() => {
              location.reload();
            });
          }
        } else {
          this.$message.error(res.message);
        }
      });
      loading.close();
    },
    // 回车登录
    keyDown(e) {
      if (e.keyCode === 13) {
        if (this.ruleForm.username !== '' && this.ruleForm.password !== '') {
          this.login();
        } else {
          this.submitForm('ruleForm');
          this.$message({
            type: 'error',
            message: '请输入账号或密码',
          });
        }
      }
    },
  },
  created() {
    this.getMsgCode();
  },
  mounted() {
    window.addEventListener('keydown', this.keyDown);
    // 路由传参判断是否是因为没有登录被拦截跳转到登录页面
    if (this.$route.query.message) {
      this.$message.warning(this.$route.query.message);
    }
  },
  destroyed() {
    window.removeEventListener('keydown', this.keyDown, false);
  },
};
</script>
<style lang="less" scoped>
// 最大的盒子
.container {
  height: 100vh;
  width: 100vw;
  overflow-y: scroll;
}
// 登录盒子
.content {
  width: 100%;
  height: calc(100% - 160px);
  background: url('~@/assets/recycling/temporaryPicture/regulatoryLogin.svg')
    no-repeat;
  background-size: cover;
  padding: 0 200px;
  .bgLogin {
    width: 100%;
    height: 100%;
    position: relative;
    .login_box {
      width: 456px;
      height: 480px;
      border-radius: 5px;
      position: absolute;
      background: #ffffff;
      right: -220px;
      top: 400px;
      transform: translate(-50%, -50%);
      box-shadow: 0px 8px 25px 0px rgba(79, 129, 208, 0.12);
      padding: 36px 40px;
    }
  }
}

// 表单最大盒子
.el-form {
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  color: rgb(204, 204, 204);
}
.codeBox {
  display: flex;
  img {
    width: 40%;
    height: 40px;
    margin-left: 12px;
    cursor: pointer;
  }
}
// 按钮
.el-button {
  z-index: 1;
  width: 100%;
  font-size: 18px;
  position: relative;
  overflow: hidden;
  transition: color 0.4s ease-in-out;
}
.el-button::before {
  content: '';
  z-index: -1;
  position: absolute;
  top: 50%;
  left: 50%;
  width: 2em;
  height: 2em;
  border-radius: 50%;
  transform-origin: center;
  transform: translate3d(-50%, -50%, 0) scale3d(0, 0, 0);
  transition: transform 0.45s ease-in-out;
}
.el-button:hover::before {
  transform: translate3d(-50%, -50%, 0) scale3d(15, 15, 15);
}
/deep/.el-form-item {
  margin: 0;
}
// 输入框背景色
/deep/.el-input__inner {
  background: transparent;
  color: #6c6666;
  height: 0 !important;
  padding: 19px 10px 19px 28px;
  background-clip: content-box;
  &::first-line {
    color: #6c6666;
  }
}
// 输入框初始颜色
/deep/.el-input__inner:-webkit-autofill {
  -webkit-text-fill-color: #6c6666;
}
// 图标位置
/deep/.el-icon-user-solid,
/deep/.el-icon-lock {
  position: absolute;
  top: 50%;
  left: 10px;
  transform: translate(0%, -50%);
}
// 提示字
/deep/.el-input__inner {
  &::placeholder {
    color: #6c6666;
    font-size: 14px;
  }
}
// 粒子背景
.login-bg {
  width: 100%;
  height: 100%;
}
// 标题
.titles {
  height: 48px;
  .header {
    height: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 200px;
    .header_name,
    .header_phone {
      font-size: 16px;
      cursor: pointer;
      .el-icon-s-home {
        color: rgb(40, 153, 254);
        margin-left: 10px;
      }
    }
    .header_name {
      font-weight: 700;
      color: rgb(34, 34, 34);
    }
    .header_phone {
      span {
        font-size: 14px;
        color: rgb(77, 81, 90);
      }
    }
    .el-icon-phone-outline {
      color: rgb(40, 153, 254);
      margin-right: 8px;
    }
  }
}
// 底部
.footers {
  position: absolute;
  left: 50%;
  bottom: 3%;
  color: #aaa;
  transform: translate(-50%, -50%);
}
/deep/::placeholder {
  color: #eee !important;
}
</style>
